<template>
  <div class="bg-muted-100 dark:bg-muted-900">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
